<template>
  <section class="import-row">
    <div class="form-group m-0">
    <router-link title="Cadastrar um novo" aria-label="Cadastrar um novo" class="btn btn-sm btn-success no-print"
      tag="button" :to="{ name: `${route}Create`}">
      <i class="fa fa-plus" aria-hidden="true"></i>
      {{ $t('words.create') }}
    </router-link>
    </div>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" id="ModalImport">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title"><i class="fa fa-upload"></i> {{$t('words.import_data')}}</p>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
          </div>
          <div class="modal-body">
            <div class="panel-body">
              <div class="alert flat alert-dismissible">
                <p>
                  <strong>
                    <i class="icon fa fa-info-circle"></i>
                    {{ $t('words.tip')}}
                  </strong>
                </p>
                {{ $t('message.import_data') }}
              </div>
              <div class="form-group" :class="{'is-invalid': errors.has('file')}">
                <label>* {{$t('attributes.file')}}</label>
                <div class="input-group">
                  <label class="input-group-btn">
                    <input type="file" name="file" v-validate="{required:true}" ref="file"
                      v-on:change="handleFileUpload()" class="form-control">
                  </label>
                </div>
                <div class="invalid-feedback help-block error">{{errors.first('file')}}</div>
              </div>
              <div class="text-center">
                <a href="#" @click="showFields" class="btn btn-default"><i class="fa fa-file-text-o"></i>
                  {{$t('words.fields')}}...</a>
              </div>
              <br>
              <div :class="{hidden:!visible}">
                <span v-html="$t('validation.field_required')"></span>
                <table class="table table-bordered">
                  <tbody>
                    <tr class="text-center" v-for="(item, i) in campos" :key="i">
                      <td class="text-right">
                        <span v-show="item.required" v-html="$t('validation.req')"></span>
                        {{item.field}}
                      </td>
                      <td class="text-left">{{item.description}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="alert flat bg-green alert-dismissible">
                <b>
                  <i class="icon fa fa-info-circle"></i>
                  Você ainda pode importar uma planilha Exportada do PDVx para uma edição em tabela, com a restrição de
                  NÂO editar o campo 'ID'.
                </b>
                <br>
              </div>
              <a href="#" @click="getExample">Baixar tabela de exemplo para novos registros</a>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default float-left" data-dismiss="modal">
              <i class="fa fa-times"></i>
              {{$t('words.cancel')}}
            </button>
            <button type="button" :disabled="loading" @click="confirmImportData()" class="btn btn-success">
              <i class="fa fa-check"></i>
              {{$t('words.save')}}
              <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" id="ModalExport">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            <p class="modal-title"><i class="fa fa-download"></i> {{$t('words.export_data')}}</p>
          </div>
          <div class="modal-body">
            <div class="panel-body">
              <div class="alert flat alert-dismissible">
                <strong>            
                    <i class="icon fa fa-info-circle"></i>
                    {{ $t('words.tip')}}
                </strong>
                <p>{{ $t('message.export_data') }}</p>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default float-left" data-dismiss="modal">
              <i class="fa fa-times"></i>
              {{$t('words.cancel')}}
            </button>
            <button v-if="exportApi" :disabled="loading" class="btn btn-success" @click="confirmExportData()"
              :name="`${route}s.xls`">
              <i class="fa fa-check"></i> Download Excel <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
            </button>
            <download-excel v-else data-dismiss="modal" class="btn btn-success" :data="json_data"
              :fields="json_fields" worksheet="Exportação PDVx" :name="`${route}s.xls`">
              <i class="fa fa-check"></i> Download Excel
            </download-excel>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import axios from 'axios';

  export default {
    props: {
      route: String,
      campos: Object,
      ignoreOption: Boolean,
      json_fields: Object,
      json_data: Array,
      exportApi: Boolean,
      exportDisabled: Boolean
    },
    data() {
      return {
        file: '',
        loading: false,
        visible: false,
        json_fields_example: {
          'Complete name': 'name',
          'City': 'city',
          'Telephone': 'phone.mobile',
          'Telephone 2': {
            field: 'phone.landline',
            callback: (value) => {
              return `Landline Phone - ${value}`;
            }
          },
        },
        json_data_example: [{
            'name': 'Tony Peña',
            'city': 'New York',
            'country': 'United States',
            'birthdate': '1978-03-15',
            'phone': {
              'mobile': '1-541-754-3010',
              'landline': '(541) 754-3010'
            }
          },
          {
            'name': 'Thessaloniki',
            'city': 'Athens',
            'country': 'Greece',
            'birthdate': '1987-11-23',
            'phone': {
              'mobile': '+1 855 275 5071',
              'landline': '(2741) 2621-244'
            }
          }
        ],
        json_meta: [
          [{
            'key': 'charset',
            'value': 'utf-8'
          }]
        ],
      };
    },
    methods: {
      handleFileUpload() {
        this.file = this.$refs.file.files[0];
      },
      importData() {
        $('#ModalImport').modal();
      },
      exportData() {
        $('#ModalExport').modal();
      },
      showFields() {
        this.visible = !this.visible;
      },
      confirmImportData() {
        //const concat = require('concat-stream');
        let formData = new FormData();
        formData.append('file', this.file);
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        this.loading = true;
        this.$validator.validateAll().then(valid => {
          if (valid) {
            axios
              .post(`/api/${this.route}/importar`, formData, config)
              .then(response => {
                this.loading = false;
                toastr({
                  icon: response.data.status,
                  title: response.data.message
                });
                $('#ModalImport').modal('hide');
              });
          } else {
            this.loading = false;
          }
        });
      },
      confirmExportData() {
        let token = localStorage.getItem('access_token');
        this.loading = true;
        $.ajax({
            type: 'POST',
            timeout: 90000,
            url: `/api/${this.route}/exportar`,
            headers: {
              authorization: `Bearer ${token}`
            },
            xhrFields: {
              responseType: 'blob'
            }
          })
          .then(response => {
            this.loading = false;
            let blob = new Blob([response], {
              type: 'data:application/vnd.ms-excel'
            });
            let downloadUrl = URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = downloadUrl;
            a.download = `Exportação PDVx - ${this.route}.xlsx`;
            document.body.appendChild(a);
            a.click();
            toastr({
              icon: 'success',
              title: 'Exportação realizada com sucesso.'
            });
            this.loading = false;
            $('#ModalExport').modal('hide');
          })
          .catch(error => {
            this.loading = false;
            toastr({
              icon: 'error',
              title: 'Ops, houve um erro ao exportar os dados..'
            });
            console.log('erro', error);
          });
      },
      getExample() {
        let token = localStorage.getItem('access_token');
        $.ajax({
            type: 'POST',
            timeout: 3000,
            url: `/api/${this.route}/exportar/exemplo`,
            headers: {
              authorization: 'Bearer ' + token
            },
            data: {
              example: true
            },
            xhrFields: {
              responseType: 'blob'
            }
          })
          .then(response => {
            this.loading = false;
            let blob = new Blob([response], {
              type: 'data:application/vnd.ms-excel'
            });
            let downloadUrl = URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = downloadUrl;
            a.download = `Exemplo de importação - ${this.route}.xlsx`;
            document.body.appendChild(a);
            a.click();
          });
      },

    }
  };
</script>